module.exports = __webpack_public_path__ + "static/img/17.07e2cb1c.jpg";